export const UPLOAD_CV_MODE_REQUEST = "UPLOAD_CV_MODE_REQUEST";
export const UPLOAD_CV_MODE_RECIEVE = "UPLOAD_CV_MODE_RECIEVE";
export const VERIFY_OTP_CODE_RECIEVE = "VERIFY_OTP_CODE_RECIEVE";
export const VERIFY_OTP_CODE_REQUEST = "VERIFY_OTP_CODE_REQUEST";
export const RESEND_OTP_CODE_REQUEST = "RESEND_OTP_CODE_REQUEST";
export const TIMER_EXPIRE = "TIMER_EXPIRE";
export const RESEND_CODE = "RESEND_CODE";
export const RESEND_OTP_CODE_RECIEVE = "RESEND_OTP_CODE_RECIEVE";
